export const CSRF_COOKIE_ID = 'X-CSRF-TOKEN';
